export default __webpack_public_path__ + "static/media/logo-creatortroya.f7c85c5f.svg";